import { Component, OnInit, ViewChild } from '@angular/core';

import { UtilHelper } from '../../_helpers/util';
import { PercentPipe, CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';
import { GeneralService } from '../../services/formulacion/general.service';
import { SeguimientoService } from 'src/app/services/formulacion/seguimiento.service';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/services/service.index';

declare const toastr: any;
@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: [],
  providers: [GeneralService]
})
export class InicioComponent implements OnInit {
  Pcalculado = 0;
  highAverage = 75;
  lowAverage = 33;
  valorfus: number = 0;
  valorPptoVigente: number = 0;
  colorEjecucion: string = '';
  message = '';
  isVisible = true;
  mesId: number = 0;
  mesIdActual: number = 0;
  data2: any[];
  pipe: any = new PercentPipe("en-US");
  pipeC: any = new CurrencyPipe("en-US");
  techos: any[];
  dataTareas: any[];
  data: any[];
  intervencion: any[];
  ejecucion: any[];
  gestion: number = 0;
  resolucion_ministerial: string = '';
  fecha_aprobacion: string = '';
  techoId: number = 0;
  resumenFUS: any = [];
  resumenTFisico: any = [];
  resumenTpresupuestario: any = [];
  resumenSeguimiento: any = [];
  rol: number = 0;
  listMeses: any[] = [];
  user: any;
  palette: string[] = ['#000eee', '#b7b5e0', '#e48cba', '#ff7c7c'];
  paletteIndex = 0;
  popupVisible: boolean = false;
  popupVisibleAnuncio: boolean = false;
  usuario: any;
  anuncio: any;
  gestionId: number = 0;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  baseUrl = environment.apiEndpoint;
  cambiar_pass: boolean = false;
  popupPassword: boolean = false;
  constructor(private _router: Router, private _gs: GeneralService, private _ss: SeguimientoService, private _as: AuthenticationService) {

    this.listaMeses();
    this.user = JSON.parse(localStorage.getItem("u"));
    
    this.rol = this.user.rol;
    this.resumenFUS = [];
    this.gestion = this.user.gestion;

    this.mesIdActual = new Date().getMonth() + 1;
    this.mesId = this.mesIdActual;
    this.usuario = this.user.nombre;
    this.cambiar_pass = this.user.cambiar_pass;
    if (this.user != null) {
     
      if ((this.rol == 23) || (this.rol == 15)) {
        this.getTechosByGestionId();
      }
      else {
        this._gs.getTechoByUO(this.user.unidad).subscribe(
          (response) => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.techos = result.data;
              if (result.data.length > 0) {
                this.techoId = result.data[0].id;
                this.gestionId = result.data[0].gestion_id;
              }
            }
            else {
              this.techos = [];
            }
          },
          (error) => { console.log('Error', error); });

        this.getNotificacionesPantallaInicio(this.user.id);

      }
    }
    else {
      window.location.href = '/login';
    }
  }

  ngOnInit() {
  }

  getTechosByGestionId() {

    this._gs.getTechoByGestionId().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.techos = result.data;
          console.log(':result.data---->', result.data);
          if (result.data.length > 0) {
            this.techoId = result.data[0].id;
            this.gestionId = result.data[0].gestion_id;
          }
        }
        else {
          this.techos = [];
        }
      },
      (error) => { console.log('Error', error); });

  }
  getResumenEjecucion(techoId: number, mesId) {
    if (this.techoId != 0 && this.mesId != 0) {
      this._gs.getDataResumenEjecucion(techoId, mesId).subscribe(
        (response) => {
          let r = UtilHelper.responses(response);
          if (r.status == 200) {
            this.data2 = r.data[0].data;
            this.valorfus = r.data[0].data[2].val;
            this.valorPptoVigente = r.data[0].data[0].val;
          } else { this.data = []; }
        },
        (error) => { console.log('Error', error); });
    }
  }

  

  getNotificacionesPantallaInicio(id: number) {
    this._gs.avisosPantallaInicio(id).subscribe(
      (response) => {
        let r = UtilHelper.responses(response);
        if (r.status == 200) {
          this.anuncio = r.data[0];
          this.popupVisibleAnuncio = true;
        } else { this.anuncio = []; }
      },
      (error) => { console.log('Error', error); });
  }

  listaMeses() {
    this._ss.getListaMeses().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.listMeses = result.data;
        }
        else {
          this.listMeses = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  onChangePOA(e: any) {
    if (e.value != undefined && e.value != null) {
      this.techoId = e.value;

      if (this.techoId != 0 && this.mesId != 0) {
        console.log(':techoId-->', this.techoId, 'mesID-->', this.mesId);
        this.getResumenFUS(this.techoId);
        this.getResumenSeguimiento(this.techoId);
        this.getResumenTFisicos(this.techoId);
        this.getResumenTpresupuestarios(this.techoId);
        this.getResumenEjecucion(this.techoId, this.mesId);
      }
    }
  }

  customizeTooltip = (arg: any) => {
    return {
      text: this.pipe.transform(arg.percent, "1.2-2")
    };
  }

  customizeTooltipLine(arg) {
    return {
      text: arg.valueText
    }
  }

  getResumenFUS(techoId: number) {
    console.log(':this.techoI-->', techoId);
    this._gs.getResumenFUS(techoId).subscribe(
      (response) => {
        let r = UtilHelper.responses(response);
        if (r.status == 200) {
          this.resumenFUS = r.data;
          console.log(':DATA FUS-->', r.data);
        }
        if (r.status == 201) {
          this.resumenFUS = [];
          this.resumenFUS.elaborado = 0;
          this.resumenFUS.aprobado = 0;
          this.resumenFUS.observado = 0;
          this.resumenFUS.anulado = 0;
        }
      },
      (error) => { console.log('Error', error); });
  }


  getResumenTFisicos(techoId: number) {

    console.log(':aqui- getResumenTFisicos-->', techoId);
    this._gs.getResumenTFisicos(techoId).subscribe(
      (response) => {
        let r = UtilHelper.responses(response);
        if (r.status == 200) {
          this.resumenTFisico = r.data;
          console.log(':DATA FISICOS-->', r.data);
        }
        if (r.status == 201) {
          this.resumenTFisico = [];
          this.resumenTFisico.elaborado = 0;
          this.resumenTFisico.aprobado = 0;
          this.resumenTFisico.observado = 0;
          this.resumenTFisico.anulado = 0;
        }
      },
      (error) => { console.log('Error', error); });
  }


  getResumenTpresupuestarios(techoId: number) {
    this._gs.getResumenTPresupuestarios(techoId).subscribe(
      (response) => {
        let r = UtilHelper.responses(response);
        if (r.status == 200) {
          console.log(':DATA PPTO-->', r.data);
          this.resumenTpresupuestario = r.data;
        }
        if (r.status == 201) {
          this.resumenTpresupuestario = [];
          this.resumenTpresupuestario.elaborado = 0;
          this.resumenTpresupuestario.aprobado = 0;
          this.resumenTpresupuestario.observado = 0;
          this.resumenTpresupuestario.anulado = 0;
        }
      },
      (error) => { console.log('Error', error); });
  }


  getResumenSeguimiento(techoId: number) {
    this._gs.getResumenSeguimiento(techoId).subscribe(
      (response) => {
        let r = UtilHelper.responses(response);
        if (r.status == 200) {
          console.log(':DATA SEG-->', r.data);
          this.resumenSeguimiento = r.data;
        }
        if (r.status == 201) {
          this.resumenSeguimiento = [];
          this.resumenSeguimiento.elaborado = 0;
          this.resumenSeguimiento.aprobado = 0;
          this.resumenSeguimiento.revisado = 0;
          this.resumenSeguimiento.consolidado = 0;
        }
      },
      (error) => { console.log('Error', error); });
  }

  onChangeMes(e) {
    this.mesId = e.value;
    this.getResumenEjecucion(this.techoId, this.mesId);
  }

  customizePoint = (arg: any) => {
    var vcalculado = 0;
    if (arg.value == this.valorfus && arg.argument == 'Ejecución FUS') {
      vcalculado = Math.round(this.valorfus * 100 / this.valorPptoVigente);
      if (vcalculado <= 49)
        return { color: '#FF0000', hoverStyle: { color: '#FF0000' } };

      if (vcalculado >= 50 && vcalculado <= 75)
        return { color: '#FFFC33', hoverStyle: { color: '#FFFC33' } };

      if (vcalculado >= 76)
        return { color: '#16C145', hoverStyle: { color: '#16C145' } };
    }
    else
      return { color: '#e48cba', hoverStyle: { color: '#e48cba' } };
  };

  customizeLabel = (arg: any, calculado: number) => {
    calculado = Math.round(arg.value * 100 / this.valorPptoVigente);
    if (calculado > 100)
      calculado = 100;
    var c = this.Pcalculado;
    return {
      visible: true,
      backgroundColor: '#b7b5e0',
      customizeText(arg) {
        return `${arg.valueText} - ${calculado}%`;
      },
    };
  };

  

  savePass() {
    if (this.valid()) {
      this._gs.postUserUpdatePass(this.user).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupPassword = false;
            this._as.logout();
            toastr.success('Contraseña actualizada exitosamente.');
          }
        });
    }
  }

  valid() {
    let res = true;

    if (this.user.password && this.user.password2) {
      const password = this.user.password.toString().trim();


      if (password.length < 8) {
        res = false;
        toastr.warning('Ingrese una contraseña que tenga al menos 8 caracteres.');
      }


      if (this.user.password !== this.user.password2) {
        res = false;
        toastr.warning('Las contraseñas no coinciden.');
      }


      const hasUppercase = /[A-Z]/.test(password);
      if (!hasUppercase) {
        res = false;
        toastr.warning('La contraseña debe contener al menos una letra mayúscula.');
      }


      const hasSpecialChar = /[!@#$%^&*_=¡(),.?":{}|<>]/.test(password);
      if (!hasSpecialChar) {
        res = false;
        toastr.warning('La contraseña debe contener al menos un carácter especial.');
      }
    } else {
      res = false;
      toastr.warning('Por favor, ingrese y confirme la contraseña.');
    }

    return res;
  }

}
